import React from 'react';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import PropTypes from 'prop-types';

import inject from '../../../../../hoc/injectHoc';
import PricingTabs from '../../../../../common/pricingTabs/PricingTabs';

/**
 * The PlanStep component.
 */
class PlanStep extends React.Component {
  /**
   * Change the currently selected plan.
   *
   * @param {{}} plan The plan object from the database.
   */
  onPlanSelect = (plan) => {
    const {purchaseFlowStore, nextStep} = this.props;

    purchaseFlowStore.setStartingPlanId(null);
    purchaseFlowStore.setPlan(plan);

    if (nextStep) {
      nextStep();
    }
  };

  /**
   * Purchase an a la carte credit
   *
   * @param {{
   *  download: number,
  *  request: number
  * }} alaCarteCreditsParam
    */
  onPurchaseCredits = (alaCarteCreditsParam) => {
    const {purchaseFlowStore, nextStep} = this.props;

    purchaseFlowStore.setStartingAlaCarteCredits(null);
    purchaseFlowStore.setAlaCarteCredits(alaCarteCreditsParam);

    if (nextStep) {
      nextStep();
    }
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {purchaseFlowStore} = this.props;

    return (<div>
      <PricingTabs
        selectPlanId={purchaseFlowStore.startingPlanId}
        onPlanSelect={this.onPlanSelect}
        canUpdatePlan={purchaseFlowStore.canUpdatePlan}
        startingCredits={purchaseFlowStore.startingAlaCarteCredit}
        onPurchaseCredits={this.onPurchaseCredits}
        canUpdateAlaCarte={purchaseFlowStore.canUpdateAlaCarte}
        user={purchaseFlowStore.currentUser}
        tabSelected={purchaseFlowStore.startingAlaCarteCredit ? 'credits' : 'subscription'}
      />
    </div>);
  }
}

PlanStep.propTypes = {
  nextStep: PropTypes.func,
  purchaseFlowStore: MobxPropTypes.observableObject,
};

PlanStep.wrappedComponent = {};
PlanStep.wrappedComponent.propTypes = {
  purchaseFlowStore: MobxPropTypes.observableObject.isRequired,
};

export default inject(PlanStep)(
  observer(PlanStep)
);
